<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17.593 17.64"
    :width="size"
    :height="size"
    class="ai-icon"
    role="img"
    aria-label="IA"
  >
    <g transform="translate(-80.024 -93.459)">
      <path
        d="m87.085 110.87c-0.06249-0.11676-0.24523-0.56197-0.4061-0.98936-1.1323-3.0081-2.3745-4.2391-5.5702-5.5196-0.82418-0.33025-1.0504-0.47094-1.0797-0.67161-0.02398-0.16414 0.03743-0.27932 0.17377-0.32592 1.0862-0.37132 2.4348-0.95889 3.0745-1.3396 1.5313-0.91119 2.7256-2.5276 3.5083-4.7483 0.45772-1.2988 0.75071-1.2936 1.2162 0.02128 0.45179 1.2761 1.2509 2.7154 1.9154 3.4496 0.80409 0.88855 1.7352 1.4757 3.3974 2.1423 0.72409 0.29041 1.3644 0.57588 1.4229 0.63438 0.22829 0.22829-0.06946 0.48116-0.92254 0.7835-1.7268 0.61198-2.843 1.2737-3.7828 2.2424-0.92184 0.95028-1.413 1.841-2.1962 3.983-0.21645 0.59194-0.5376 0.73649-0.75088 0.33797zm6.7458-10.122c-0.06334-0.0823-0.23577-0.45381-0.38318-0.8255-0.37991-0.95793-1.2011-1.8169-2.1109-2.2081-1.3131-0.56466-1.327-0.59976-0.3813-0.96229 1.2223-0.46852 1.7809-0.98714 2.3748-2.2047 0.4641-0.95144 0.8109-1.3472 0.8109-0.9254 0 0.31721 0.7966 1.7835 1.1701 2.1538 0.3768 0.37354 1.8473 1.1735 2.1572 1.1735 0.08144 0 0.14808 0.07184 0.14808 0.15964 0 0.08804-0.29877 0.27213-0.6661 0.41044-1.3089 0.49283-2.1737 1.3613-2.6523 2.6636-0.24224 0.65915-0.32133 0.75481-0.46726 0.56509z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width=".43784"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 16,
    },
  },
};
</script>

<style scoped>
.ai-icon {
  display: block;
}
</style>
